export const TRACE_ID_HEADER = 'X-Trace-Id';

const TRACE_ID_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._-]{0,127}$/;

const byteToHex = (byte: number) => byte.toString(16).padStart(2, '0');

export const isValidTraceId = (traceId?: string | null): traceId is string => (
  typeof traceId === 'string' && TRACE_ID_PATTERN.test(traceId)
);

export const generateTraceId = (): string => {
  const bytes = new Uint8Array(16);
  const browserCrypto = typeof window !== 'undefined' ? window.crypto : undefined;

  if (browserCrypto?.getRandomValues) {
    browserCrypto.getRandomValues(bytes);
    return Array.from(bytes, byteToHex).join('');
  }

  return Array.from(bytes, () => Math.floor(Math.random() * 256))
    .map(byteToHex)
    .join('');
};

const normalizeHeaderValue = (value: unknown): string | undefined => {
  if (Array.isArray(value)) {
    return normalizeHeaderValue(value[0]);
  }
  return typeof value === 'string' ? value : undefined;
};

export const extractTraceIdFromHeaders = (headers: unknown): string | undefined => {
  if (!headers || typeof headers !== 'object') {
    return undefined;
  }

  const headerReader = headers as { get?: (name: string) => unknown };
  let rawTraceId: string | undefined;

  if (typeof headerReader.get === 'function') {
    rawTraceId = normalizeHeaderValue(headerReader.get(TRACE_ID_HEADER))
      || normalizeHeaderValue(headerReader.get(TRACE_ID_HEADER.toLowerCase()));
  }

  if (!rawTraceId) {
    const headerEntry = Object.entries(headers as Record<string, unknown>)
      .find(([key]) => key.toLowerCase() === TRACE_ID_HEADER.toLowerCase());
    rawTraceId = normalizeHeaderValue(headerEntry?.[1]);
  }

  return isValidTraceId(rawTraceId) ? rawTraceId : undefined;
};
